import React from 'react'

export default function Navigation() {
    return (
        <>
            <ul>
                <li
                    id="borrow"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/borrow/">Personal Loans</a>
                </li>
                <li
                    id="pawn"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/pawns/">Pawn With Us</a>
                </li>
                <li
                    id="sell"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/sell/">Sell To Us</a>
                </li>
                <li
                    id="buy"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/buy/">Buy From Us</a>
                </li>
                <li
                    id="stores"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/stores/">Our Stores</a>
                </li>
                <li
                    id="about"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/about-us/">About Us</a>
                </li>
                <li
                    id="join"
                    className="menu-item-has-children active"
                >
                    <a href="/">Join Us</a>
                </li>
                <li
                    id="contact"
                    className="menu-item-has-children"
                >
                    <a href="https://cashconverters.co.nz/contact-us/">Contact Us</a>
                </li>
            </ul>
        </>
    )
}